var PushMultiAppsService = /** @class */ (function () {
    function PushMultiAppsService(api) {
        var _this = this;
        this.fetchPushMultiApps = function (appId) { return _this.API.get("/apps/".concat(appId, "/push_share")); };
        this.createPushMultiApp = function (appId, pushMultiAppId) {
            return _this.API.post("/apps/".concat(appId, "/push_share/").concat(pushMultiAppId));
        };
        this.deletePushMultiApp = function (appId, pushMultiAppId) {
            return _this.API.delete("/apps/".concat(appId, "/push_share/remove/").concat(pushMultiAppId));
        };
        this.getPushReceiverAppsGroups = function (appId) {
            return _this.API.get("/apps/".concat(appId, "/push_share/groups"));
        };
        this.API = api;
    }
    return PushMultiAppsService;
}());
export { PushMultiAppsService };
